// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"86":"da3ee6a8","509":"ca20c6f1","780":"ca20c6f1","836":"ca20c6f1"}[chunkId] + ".chunk.css";
};